import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaChartLine, FaUsers, FaLightbulb, FaDatabase, FaCogs, FaHandshake } from "react-icons/fa";
import { Link } from "react-router-dom";

const ExpertiseSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, mirror: true, once: false });
  }, []);

  return (
    <section className="expertise-section py-5">
      <div className="container">
        <div className="row align-items-center">
          
          
          <div className="col-lg-6 image-grid" data-aos="fade-right">
            <div className="row">
              <div className="col-md-6">
                <img
                  src="../assets/images/image17.png"
                  alt="Remise de diplôme"
                  className="img-fluid rounded shadow"
                />
              </div>
              <div className="col-md-6">
                <img
                  src="../assets/images/image18.png"
                  alt="Réunion d'affaires"
                  className="img-fluid rounded shadow"
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <img
                  src="../assets/images/image19.png"
                  alt="Équipe en discussion"
                  className="img-fluid rounded shadow"
                />
              </div>
            </div>
            
            <div className="text-center mt-3">
              <Link to="/contact" className="contact-button" data-aos="zoom-in">
                Contactez-nous
              </Link>
            </div>
          </div>

          
          <div className="col-lg-6 text-content" data-aos="fade-left">
            <span className="section-indicator">• Notre Expertise</span>
            <h2 className="fw-bold text-left">
              Accompagner les entreprises <br />
              <span className="gradient-text">avec des stratégies innovantes</span>
            </h2>
            <p className="text-justify">
              Nous proposons des solutions sur mesure pour améliorer l’efficacité opérationnelle et favoriser la croissance de votre entreprise.
            </p>

            
            <div className="row service-list">
              <div className="col-md-6">
                <ul>
                  <li><FaChartLine className="icon" /> Optimisation des performances</li>
                  <li><FaLightbulb className="icon" /> Solutions adaptées</li>
                  <li><FaDatabase className="icon" /> Analyse de marché</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul>
                  <li><FaUsers className="icon" /> Gestion des talents</li>
                  <li><FaCogs className="icon" /> Décisions basées sur les données</li>
                  <li><FaHandshake className="icon" /> Intégration technologique</li>
                </ul>
              </div>
            </div>

            
            <div className="row icon-text text-left">
              <div className="col-md-6 text-center" data-aos="flip-left">
                <FaUsers className="icon-large" />
                <p><strong>Planification stratégique</strong></p>
              </div>
              <div className="col-md-6 text-center" data-aos="flip-right">
                <FaCogs className="icon-large" />
                <p><strong>Optimisation des processus</strong></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      <style>{`
        .expertise-section {
          background: #fff;
          padding: 80px 0;
        }

        .section-indicator {
          color: #e63946;
          font-weight: bold;
          text-transform: uppercase;
          display: block;
          margin-bottom: 10px;
        }

        .gradient-text {
          background: linear-gradient(90deg, #2a77ff, #e63946);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .text-justify {
          text-align: justify;
        }

        .service-list ul {
          list-style: none;
          padding: 0;
        }

        .service-list li {
          font-size: 16px;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;
        }

        .icon {
          color: #e63946;
        }

        .icon-large {
          font-size: 40px;
          color: #e63946;
        }

        .contact-button {
          background: linear-gradient(45deg, #2a77ff, #e63946);
          color: white;
          padding: 12px 24px;
          border-radius: 50px;
          font-weight: bold;
          text-decoration: none;
          display: inline-block;
          transition: transform 0.3s ease-in-out;
        }

        .contact-button:hover {
          transform: scale(1.1);
          opacity: 0.8;
        }
      `}</style>
    </section>
  );
};

export default ExpertiseSection;
